/**
 * CZNA-1410 — the MARC catalog the record form reads to let a cataloguer add a
 * subfield the template does not declare (`utils/addableSubfields.ts`).
 *
 * <p>A context rather than a query inside every field panel: the record form
 * mounts the provider once, and a panel rendered outside it — a test, the
 * settings preview — gets no catalog and behaves exactly as before: nothing to
 * add, and the subfields outside the template stay read-only.
 */
import React, { createContext, useContext } from 'react';
import { useSemanticCatalog } from '../../../hooks/useSemanticCatalog';
export var SubfieldCatalogContext = createContext(undefined);
export var useSubfieldCatalog = function () { return useContext(SubfieldCatalogContext); };
export var SubfieldCatalogProvider = function (_a) {
    var children = _a.children;
    // Every role that can open the record form reads the catalog (CZNA-1291), so the
    // query is not gated; without the catalog the form simply offers nothing.
    var data = useSemanticCatalog().data;
    return React.createElement(SubfieldCatalogContext.Provider, { value: data }, children);
};
